import { rootApi } from "../../api/rootApi";

export const iffcoApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchIffcoExpiryAgeing: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params.query || {}).toString();
        return {
          method: "GET",
          url: `/app/iffco/reports/expiry-ageing?${queryParams}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    fetchIffcoInventorySummary: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params.query || {}).toString();
        return {
          method: "GET",
          url: `/app/iffco/reports/inventory-summary?${queryParams}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    fetchIffcoScanActivityLog: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params.query || {}).toString();
        return {
          method: "GET",
          url: `/app/iffco/reports/scan-activity-log?${queryParams}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    fetchIffcoRetailerCoverage: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params.query || {}).toString();
        return {
          method: "GET",
          url: `/app/iffco/reports/retailer-coverage?${queryParams}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    fetchIffcoUnscannedQr: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params.query || {}).toString();
        return {
          method: "GET",
          url: `/app/iffco/reports/unscanned-qr?${queryParams}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useFetchIffcoExpiryAgeingQuery,
  useLazyFetchIffcoExpiryAgeingQuery,
  useFetchIffcoInventorySummaryQuery,
  useLazyFetchIffcoInventorySummaryQuery,
  useFetchIffcoScanActivityLogQuery,
  useLazyFetchIffcoScanActivityLogQuery,
  useFetchIffcoRetailerCoverageQuery,
  useLazyFetchIffcoRetailerCoverageQuery,
  useFetchIffcoUnscannedQrQuery,
  useLazyFetchIffcoUnscannedQrQuery,
} = iffcoApi;
